import { useCallback, useMemo, useState } from "react";
import useAppSelector from "@/core/helpers/useAppSelector.ts";
import useInterfaceSoundCore from "@/shared/hooks/useInterfaceSoundCore";
import { PlayIcon } from "@/shared/icons";
import { Soundtrack } from "@/shared/sounds";
import { Button, Confirm } from "@/shared/ui";
import { characterByIdSelector, selectedCharIdSelector } from "@/domains/account/slice.ts";
import useEnterToGame from "@/domains/account/hooks/useEnterToGame";

export default function AccountCharPlayContainer() {
  const { play } = useInterfaceSoundCore(Soundtrack.EnterGame);
  const { enterHandler, isPending } = useEnterToGame();
  const [open, setOpen] = useState(false);
  const selectedCharId = useAppSelector(selectedCharIdSelector);
  const character = useAppSelector((state) => characterByIdSelector(state, selectedCharId));

  const name = useMemo(() => {
    if (character) {
      return [character?.firstName || "", character?.lastName || ""].join(" ");
    }
    return "";
  }, [character]);

  const onToogleModal = useCallback(() => {
    setOpen((state) => !state);
  }, []);

  const onConfirm = useCallback(async () => {
    play();
    await enterHandler(String(selectedCharId));
  }, [selectedCharId, play]);

  return (
    <>
      <Button onClick={onToogleModal}>
        <PlayIcon size={20} className="mr-2.5" />
        Начать игру
      </Button>
      <Confirm open={open} onConfirm={onConfirm} onCancel={onToogleModal} pending={isPending}>
        <div className="text-white text-16 font-bold text-center">
          Войти в игру как <span className="text-accent">{name}</span>
        </div>
      </Confirm>
    </>
  );
}
